import { render, staticRenderFns } from "./integrogram.vue?vue&type=template&id=1fbec3e1&scoped=true&"
import script from "./integrogram.vue?vue&type=script&lang=js&"
export * from "./integrogram.vue?vue&type=script&lang=js&"
import style0 from "./integrogram.vue?vue&type=style&index=0&id=1fbec3e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbec3e1",
  null
  
)

export default component.exports